













































































import Vue from 'vue';
import VariableInput from '@/components/util/VariableInput.vue';
import SelectBox from "@/components/util/SelectBox.vue";
import CorporateSideTabs from "@/parts/corporate/CorporateSideTabs.vue";

export interface CardFormResult {
  message?: string;
  cardForm?: {  cardToken: string, cardSaveFlg?: boolean, }; 
}

export interface Card {
  card_no: string;
  expire: string;
  security_code: string;
  holder_name: string;
  number: number;
}

export default Vue.extend({
  name: 'CorpPaymentForm',
  components: {
    VariableInput,
    SelectBox,
    CorporateSideTabs,
  },
  props: {
    showCardSave: {
      type: Boolean,
      default: false,
    },
    cardData: {},
  },
  data() {
    return {
      card: {
        card_no: '',
        expire: '',
        security_code: '',
        holder_name: '',
        number: 1
      } as Card,
      cardForm: {
        cardName: '',
        cardToken: '',
        cardSaveFlg: false,
      },
      numberElement: null as any,
      months: [
        {value: 0, text: '-'},
        {value: 1, text: '01'},
        {value: 2, text: '02'},
        {value: 3, text: '03'},
        {value: 4, text: '04'},
        {value: 5, text: '05'},
        {value: 6, text: '06'},
        {value: 7, text: '07'},
        {value: 8, text: '08'},
        {value: 9, text: '09'},
        {value: 10, text: '10'},
        {value: 11, text: '11'},
        {value: 12, text: '12'},
      ],
      years: [
        {value: 0, text: '-'},
      ] as any,
      month: 0,
      year: 0,
    }
  },
  computed: {
    currentPath() {
      return this.$route.path;
    },
  },
  mounted() {
    this.createCardFrom();
    this.createExpireYear();
    this.initCard();

    const cardNumberInput = document.querySelector('#card-number-input input') as HTMLInputElement;
    cardNumberInput.addEventListener('input', () => {
      cardNumberInput.value = cardNumberInput.value.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim();
    });

    const cardExpireInput = document.querySelector('#card-expire-input input') as HTMLInputElement;
    cardExpireInput.addEventListener("input", () => {
      const inputValue = cardExpireInput.value;
      if (inputValue.length === 2) {
        cardExpireInput.value = inputValue + " / ";
      }
    });
  },
  methods: {
    createCardFrom() {
      if(this.$fincode == null){
        Vue.prototype.$fincode = window.Fincode(process.env.VUE_APP_FINCODE_PUBLIC_KEY);
      }
    },
    initCard() {
      if ((this.cardData as Card).card_no) {
        this.card.card_no = (this.cardData as Card).card_no.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim();
        this.card.holder_name = (this.cardData as Card).holder_name;
        this.card.expire = (this.cardData as Card).expire;
        this.month = Number(this.card.expire.substring(0, 2));
        this.year = Number(this.card.expire.substring(5, 8));
      }
    },
    async validation(): Promise<CardFormResult> {
      const form = this.cardForm;
      const cardNameRegExp = /[^A-Z\s]+/;
      // カード名義
      if(!this.card.holder_name.trim()){
        return { message: 'カード名義を入力してください' };
      }
      if(this.card.holder_name.match(cardNameRegExp)){
        return { message: 'カード名義を大文字英字で入力してください' };
      }
      // カード番号整形
      const card_no = this.card.card_no.replace(/\D/g, "");
      // 有効期限整形
      var expire = this.card.expire.replace(/\D/g, "");
      expire = expire.slice(2) + expire.slice(0, 2);

      const card = {
        card_no: card_no,
        expire: expire,
        security_code: this.card.security_code,
        holder_name: this.card.holder_name,
        number: this.card.number
      }
      //トークン発行
      const response = await new Promise<{ list: { token: string }[] }>((resolve, reject) => {
        this.$fincode.tokens(card, function(status: any, response: any) {
          if (status === 200) {
            resolve(response);
          } else {
            reject(response);
          }
        });
      }).catch((e) => {
        console.log(e);
        return;
      });
      if (response && response.list) {
        this.cardForm.cardToken = response.list[0].token;
      }
      const { cardName, ...rest } = form;
      if(this.showCardSave){
        return { cardForm: rest };
      } else {
        return { cardForm: { cardToken: form.cardToken } };
      }
    },
    createExpireYear() {
      var startYear = 2000;
      for (var i = 1; i < 50; i++) {
        this.years.push({value: i, text: String(startYear + i)});
      }
    },
    changeMonth(month: string) {
      this.month = Number(month);
      this.changeExpire();
    },
    changeYear(year: string) {
      this.year = Number(year);
      this.changeExpire();
    },
    changeExpire() {
      if (this.month > 0 && this.year > 0) {
        let _month = String(this.month);
        let _year = String(this.year);
        this.card.expire = (this.month < 9 ? '0' + _month : _month) + ' / ' + (this.year < 9 ? '0' + _year : _year);
      }
    },
  },
})
